import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import omit from 'lodash/omit';
import { Field } from 'redux-form';

const OptionInput = (props) => {
  const id = props.id || uniqueId('option-');
  const triggerClass = `c-radio__trigger c-radio__trigger_size-${props.size}`;
  const labelClassName = `c-radio ${props.className}`;

  return (
    <label className={labelClassName} htmlFor={id}>
      <Field
        {...omit(props, ['children'])}
        id={id}
        className="c-radio__input"
        type="radio"
        component="input"
      />
      <span className={triggerClass} />
      <span className="c-radio__label">
        {props.children}
      </span>
    </label>
  );
};
OptionInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};
OptionInput.defaultProps = {
  id: null,
  name: '',
  value: '',
  children: null,
  size: 'm',
  className: '',
  onChange: () => {},
};

export default OptionInput;
